import CardComponent from "./CardComponent";

export class Avatar extends CardComponent {

}
